// require("./lib/social");
// require("./lib/ads");
require("./bc-preroll");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(12033845), 3000);
var animateScroll = require("./lib/animateScroll");
var track = require("./lib/tracking");



require("component-responsive-frame/child");


//var colors = require("./lib/colors");

//var matrix = $.one(".matrix");
//var key = $.one(".key");
//var detail = $.one(".detail");




var goget = document.getElementById("goget");
goget.addEventListener("click", scrollthere);
function scrollthere(){
	var latest = document.getElementById("Latest");
	animateScroll(latest);
};

var aboutnav = document.getElementById("aboutnav");
aboutnav.addEventListener("click", aboutus);
function aboutus(){
	var about = document.getElementById("about");
	animateScroll(about);
};